// extracted by mini-css-extract-plugin
var _1 = "sokn7myJvQn1zr8AVYFg";
var _2 = "K5msERxdzXFZNhasyXWK";
var _3 = "vfWhaTGhTnjIAqzyHfvB";
export { _1 as "body_transition", _2 as "dark", _3 as "light" }
